<template>
    <div class="stipSucceedBox">
        <div class="succeedImgBox">
            <img src="../../../assets/img/wxPay/cg.svg"/>
        </div>
        <div class="succeed" >
            缴费成功
        </div>

        <div class="fanHui" @click="returnFn">返回</div>

        <div class="wxts">
            温馨提示：为了避免再次计费，请在缴费后30分钟内离场。
        </div>
    </div>
</template>

<script>
    export default {
        name: "stopCarSucceed",
        methods:{
            returnFn(){
                this.$router.push("/")
            }
        }
    }
</script>

<style lang="scss" scoped>
.stipSucceedBox{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    .succeedImgBox{
        margin-top: 38%;

    }
    .succeed{
        font-size: 16px;
        margin-top: 10px;
        color: #4ddb8d;
        letter-spacing: 1px;
    }
    .wxts{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        border: 1px solid #f4b190;
        background: #f7c699;
        opacity: 0.9;
    }
    .fanHui{
        width: 100px;
        height:40px;
        line-height: 40px;
        text-align: center;
        margin-top: 14%;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid #00C800;
    }
}
</style>
